import React from 'react';
import VideoModal from '../../UI/VideoModal';

export type { WorkDetail } from '../../UI/VideoModal';

type WorkDetailModalProps = React.ComponentProps<typeof VideoModal>;

const WorkDetailModal: React.FC<WorkDetailModalProps> = (props) => {
    return <VideoModal {...props} />;
};

export default WorkDetailModal;
